<div class="modal-header">
    <h3 class="modal-title font-bold" id="modal-title">Confirm</h3>
</div>
<div class="modal-body" id="modal-body">
    {{fromParent.relayConfirmMsg}}
</div>
<div class="modal-footer confirm-footer">
    <button class="btn btn-warning btn-sm" type="button" *ngIf="!fromParent.relayConfirmCancel"
        (click)="cancelModal()">Cancel</button>
    <button class="btn btn-primary btn-sm" type="button" *ngIf="!fromParent.relayConfirmCancel"
        (click)="confirmModal()">Confirm</button>

    <!-- buttons for Cancel Confirmation Modal -->
    <button class="btn btn-primary btn-sm" type="button" *ngIf="fromParent.relayConfirmCancel"
        (click)="confirmModal()">Cancel</button>
    <button class="btn btn-warning btn-sm" type="button" *ngIf="fromParent.relayConfirmCancel"
        (click)="cancelModal()">No</button>
</div>